import { Box, Tooltip } from "@mui/material";
import {
  MeetingRoomCapacityBox,
  MeetingRoomCapacityWrapper,
  MeetingRoomEmojiPeopleIcon,
  MeetingRoomListItemRightSection,
  MeetingRoomListItemRow,
  MeetingRoomListItemStyle,
  MeetingRoomName,
  MeetingRoomReservationButton,
} from "./MeetingRoomListItemStyled";
import { memo, useCallback } from "react";
import { useDeviceType } from "../../../hooks/useDeviceType";
import {
  MeetingRoomStatusInfo,
  OutlookDeepLinkParam,
} from "../../../system/types/meetingRoom/MeetingRoom";
import { useMeetingRoom } from "../../../hooks/MeetingRoom/useMeetingRoom";
import AlertModal from "../../Common/AlertModal";

type MeetingRoomListItemProps = {
  info: MeetingRoomStatusInfo;
  idx: number;
  selectedId: string;
  onClick: any;
  handleOpenOutlookPopup: (params: OutlookDeepLinkParam[]) => void;
  handleOpenGuidePopup: (
    status: boolean,
    params: OutlookDeepLinkParam[]
  ) => void;
};

const MeetingRoomListItem = memo(
  ({
    info,
    idx,
    selectedId,
    onClick,
    handleOpenOutlookPopup,
    handleOpenGuidePopup,
  }: MeetingRoomListItemProps) => {
    const deviceType = useDeviceType();
    const { isAvailable } = info;
    const { checkShowPopup } = useMeetingRoom();

    // 현재 사용가능한 회의실인지 확인 후 DeepLink Open
    const handleOpenGuideOrDeepLinkPopup = useCallback(
      (e, room: any) => {
        if (isAvailable) {
          const showPopup = checkShowPopup();
          const params: OutlookDeepLinkParam[] = [
            { key: "cc", value: `${room.displayName} <${room.mail}>` },
          ];
          if (showPopup) {
            handleOpenGuidePopup(true, params);
          } else {
            handleOpenOutlookPopup(params);
          }
        } else {
          AlertModal("check", "현재 시간에 이미 등록된 예약이 있습니다.");
        }
      },
      [
        isAvailable,
        checkShowPopup,
        handleOpenGuidePopup,
        handleOpenOutlookPopup,
      ]
    );

    return (
      <Tooltip
        title={
          info.roomInfo.capacity === 0
            ? ""
            : `${info.name}은 최대 ${info.roomInfo.capacity}명까지 이용 가능합니다.`
        }
        placement="right-start"
      >
        <Box
          component="li"
          sx={MeetingRoomListItemStyle(
            idx,
            info.id === selectedId,
            isAvailable ?? true,
            deviceType
          )}
          onClick={() => onClick(info)}
        >
          <MeetingRoomListItemRow>
            <MeetingRoomName>{info.name}</MeetingRoomName>

            {/* 오른쪽 영역: 인원 수 + 예약 버튼 */}
            <MeetingRoomListItemRightSection>
              {/* 인원 아이콘 + 숫자 */}
              {info.roomInfo.capacity !== 0 && (
                <MeetingRoomCapacityWrapper>
                  <MeetingRoomEmojiPeopleIcon />

                  <MeetingRoomCapacityBox>
                    {info.roomInfo.capacity}
                  </MeetingRoomCapacityBox>
                </MeetingRoomCapacityWrapper>
              )}
              {/* 예약 버튼 */}
              <MeetingRoomReservationButton
                className="meeting-room-list-item-reservation-button"
                onClick={(e) =>
                  handleOpenGuideOrDeepLinkPopup(e, info.roomInfo)
                }
              >
                예약
              </MeetingRoomReservationButton>
            </MeetingRoomListItemRightSection>
          </MeetingRoomListItemRow>
        </Box>
      </Tooltip>
    );
  }
);

export default MeetingRoomListItem;
